import React, { useEffect, useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";

export default function AccessibleVideo({
  src,
  type = "video/mp4",
  className = "object-cover h-full",
  style = {},
  autoPlay = true,
  muted = true,
  playsInline = true,
  loop = true,
  showControlsButton = true,
  buttonClassName = "",
  playLabel = "Riproduci il video",
  pauseLabel = "Metti in pausa il video",
  children,
  ...rest
}) {
  const videoRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

   useEffect(() => {
    const video = videoRef.current;
    if (!video || !autoPlay) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const tryPlay = async () => {
      try {
        await video.play();
        setIsPaused(false);
      } catch (error) {
        setIsPaused(true);
        console.warn("Autoplay non riuscito:", error);
      }
    };

    tryPlay();
  }, [autoPlay, src]);

  const togglePlayback = async () => {
    const video = videoRef.current;
    if (!video) return;

    try {
      if (video.paused) {
        await video.play();
        setIsPaused(false);
      } else {
        video.pause();
        setIsPaused(true);
      }
    } catch (error) {
      console.error("Errore play/pause video:", error);
    }
  };

  return (
    <div className="relative w-full h-full">
      <video
        ref={videoRef}
        className={className}
        style={style}
        autoPlay={autoPlay}
        muted={muted}
        playsInline={playsInline}
        loop={loop}
        preload="auto"
        onPlay={() => setIsPaused(false)}
        onPause={() => setIsPaused(true)}
        aria-hidden="true"
        {...rest}
      >
        <source src={src} type={type} />
        Il tuo browser non supporta il tag video.
      </video>

      {showControlsButton && (
        <button
          type="button"
          onClick={togglePlayback}
          className={`absolute bottom-5 left-6 z-30 bg-black/60 text-white px-4 py-2 rounded-full focus:outline-none focus:ring-2 focus:ring-[#b7955a] ${buttonClassName}`}
          aria-label={isPaused ? playLabel : pauseLabel}
        >
          {isPaused ? <FaPlay /> : <FaPause />}
        </button>
      )}

      {children}
    </div>
  );
}